import { z } from "zod";

export enum ImageEnhancement {
    MODERN = "modern",
    LUXURY = "luxury",
    MINIMALIST = "minimalist",
    COZY = "cozy",
}

export const functions = {
    "ai-api-image": {
        input: z.object({
            enhancement: z.nativeEnum(ImageEnhancement),
            imageId: z.string().uuid(),
        }),
        output: z.object({
            imageURL: z.string().url(),
        }),
    },
    "discord-notify": {
        input: z.object({
            message: z.string().min(1, "Message is required"),
            data: z.record(z.unknown()).optional(),
            username: z.string().optional(),
        }),
        output: z.any(),
    },
    "contact-seller": {
        input: z.object({
            buyerName: z.string().min(2, 'Name must be at least 2 characters.'),
            buyerEmail: z.string().email('Please enter a valid email address.'),
            buyerPhone: z.string().optional(),
            message: z.string().min(10, 'Message must be at least 10 characters.').max(400, 'Message must be at most 300 characters.'),
            propertyId: z.string().uuid()
        }),
        output: z.any(),
    },
    "create-checkout-session": {
        input: z.object({
            priceId: z.string(),
            metadata: z.record(z.string()).optional(),
        }),
        output: z.object({
            id: z.string(),
            client_secret: z.string(),
        }),
    },
    "id-confirm": {
        input: z.void(),
        output: z.object({
            client_secret: z.string()
        }),
    },
    "vsai-api-image": {
        input: z.object({
            prompt: z.string().min(1, "Prompt is required"),
            bucket: z.string(),
            path: z.string(),
            imageId: z.string(),
        }),
        output: z.object({
            imageURL: z.string().url(),
        }),
    },
    "stripe-create-checkout": {
        input: z.object({
            priceId: z.string(),
            successURL: z.string().url(),
            metadata: z.record(z.string()).optional(),
        }),
        output: z.object({
            id: z.string(),
            url: z.string().url(),
        }),
    },
} as const satisfies Record<string, {
    input: z.ZodSchema,
    output: z.ZodSchema,
}>;

